<script setup lang="ts">
const { hotelData, propertyCode } = defineProps<{
  hotelData: Partial<HotelInfoExpand>;
  propertyCode: string;
}>();

const FACILITY_TRANSLATION_TOKEN = {
  roofTopBar: "website.pagetype.hotel.facilities.bar.page.link.label",
  restaurantAndBar: "website.pagetype.hotel.facilities.bar.page.link.label",
};

const { t } = useI18n();
const localePath = useLocalePath();

const { hotels } = useHotels();
const currentHotel = computed(() =>
  hotels.value.find((hotel) => hotel.propertyCode === propertyCode),
);

/**
 *
 * TODO: this logic should be replaced in favor of property endpoints for bars to grab slug from property code
 */
function resolveBarLink(facility: GoodbitsPropertyExpandBar) {
  if (!facility || !currentHotel.value) {
    return undefined;
  }

  if (facility.type === "restaurantAndBar") {
    return localePath(
      `/hotels/${currentHotel.value.slug}/${slugify(currentHotel.value.propertyCode)}-canteenm`,
    );
  }

  return localePath(
    `/rooftop-bars/${currentHotel.value.slug.replace(/-hotel/g, "")}`,
  );
}

function isBarFacility(facility: any): facility is GoodbitsPropertyExpandBar {
  return (
    "menuCode" in facility &&
    ["roofTopBar", "restaurantAndBar"].some((type) => type === facility?.type)
  );
}

const facilityBaseData = computed(() => [
  ...(hotelData?.bars || []),
  ...(hotelData?.bar ? [hotelData.bar] : []),
  ...(hotelData?.roofTopBar ? [hotelData.roofTopBar] : []),
  ...(hotelData?.pools || []),
  ...(hotelData?.genericFacilities || []),
  ...(hotelData?.coworkings || []),
]);

const resolvedFacilities = computed(() => {
  return facilityBaseData.value.map((facility) => ({
    title: facility.title,
    text: facility.description,
    image: facility.heroImage,
    ...(isBarFacility(facility) && {
      buttonUrl: resolveBarLink(facility),
      buttonText: t(FACILITY_TRANSLATION_TOKEN[facility.type]),
      buttonTarget: "_blank",
    }),
  }));
});
</script>

<template>
  <ContentfulColumns
    :title="t('website.pagetype.hotel.property_hightlights')"
    :columns="resolvedFacilities"
    :columnsPerView="4"
    data-component="curatedCollection"
    data-component-variant="slider"
  />
</template>
